export default function Completed() {

    return(
        <svg xmlns="http://www.w3.org/2000/svg" width="31" height="30" viewBox="0 0 32 31" fill="none">
            <rect x="1.41602" y="0.5" width="29" height="29" rx="14.5" fill="#0BA9B5"/>
            <rect x="1.41602" y="0.5" width="29" height="29" rx="14.5" stroke="#0BA9B5"/>
            <path d="M9.7376 16.6013L13.5664 20.3226C13.9544 20.6998 14.5722 20.6998 14.9603 20.3226L23.262 12.2539C23.666 11.8612 23.666 11.2124 23.262 10.8197L23.1156 10.6774C22.7275 10.3002 22.1097 10.3002 21.7216 10.6774L14.9603 17.249C14.5722 17.6262 13.9544 17.6262 13.5664 17.249L11.2779 15.0248C10.8899 14.6476 10.2721 14.6476 9.884 15.0248L9.7376 15.1671C9.33356 15.5598 9.33356 16.2086 9.7376 16.6013Z" fill="white"/>
        </svg>
    )
}